var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageAlignmentRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1362 3.68182C21.1362 3.30526 21.4415 3 21.818 3C22.1946 3 22.4999 3.30526 22.4999 3.68182V20.3182C22.4999 20.6947 22.1946 21 21.818 21C21.4415 21 21.1362 20.6947 21.1362 20.3182V3.68182Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 6C18 5.17157 17.3284 4.5 16.5 4.5H4.5C3.67157 4.5 3 5.17157 3 6V18C3 18.8284 3.67157 19.5 4.5 19.5H16.5C17.3284 19.5 18 18.8284 18 18V6ZM5.25 6C4.83579 6 4.5 6.33579 4.5 6.75V17.25C4.5 17.6642 4.83579 18 5.25 18H15.75C16.1642 18 16.5 17.6642 16.5 17.25V6.75C16.5 6.33579 16.1642 6 15.75 6H5.25Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.24943 12C9.49208 12 10.4994 10.9926 10.4994 9.75C10.4994 8.50736 9.49208 7.5 8.24943 7.5C7.00679 7.5 5.99943 8.50736 5.99943 9.75C5.99943 10.9926 7.00679 12 8.24943 12ZM8.24943 10.5C8.66365 10.5 8.99943 10.1642 8.99943 9.75C8.99943 9.33579 8.66365 9 8.24943 9C7.83522 9 7.49943 9.33579 7.49943 9.75C7.49943 10.1642 7.83522 10.5 8.24943 10.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6938 10.2921C14.4075 9.9927 13.9328 9.98205 13.6334 10.2683L3.75 18.9027L5.24991 19.5L14.1279 11.8708L16.5 14.25L17.5842 13.2134L14.6938 10.2921Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageAlignmentRight);
export default __webpack_public_path__ + "static/media/image-alignment-right.145c6ac1b1564d590f0f5d2841698835.svg";
export { ForwardRef as ReactComponent };